"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { combinedTax } from "@/lib/cart-pricing";
import { useCart } from "@/queries/useCart";
import { OrderSummaryCoupon } from "./OrderSummaryCoupon";
import { OrderSummaryHeader } from "./OrderSummaryHeader";
import { OrderSummaryLine } from "./OrderSummaryLine";
import { OrderSummarySitewidePromo } from "./OrderSummarySitewidePromo";
export function OrderSummary() {
  const $ = _c(32);
  const [isOpen, setIsOpen] = useState(false);
  const {
    data: cart
  } = useCart();
  if (!cart?.items?.length) {
    return null;
  }
  const {
    pricing
  } = cart;
  let t0;
  if ($[0] !== pricing.salesTax || $[1] !== pricing.shippingTax) {
    t0 = combinedTax(pricing.salesTax, pricing.shippingTax);
    $[0] = pricing.salesTax;
    $[1] = pricing.shippingTax;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const estimatedTax = t0;
  let t1;
  if ($[3] !== isOpen || $[4] !== pricing) {
    t1 = <CollapsibleTrigger asChild={true}><OrderSummaryHeader isOpen={isOpen} pricing={pricing} /></CollapsibleTrigger>;
    $[3] = isOpen;
    $[4] = pricing;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== pricing.subTotal) {
    t2 = <OrderSummaryLine label="Subtotal" value={pricing.subTotal} />;
    $[6] = pricing.subTotal;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== pricing.shippingAmount) {
    t3 = <OrderSummaryLine label="Estimated Shipping*" value={pricing.shippingAmount} isEstimate={true} />;
    $[8] = pricing.shippingAmount;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== estimatedTax) {
    t4 = <OrderSummaryLine label="Estimated Tax*" value={estimatedTax} isEstimate={true} />;
    $[10] = estimatedTax;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== pricing.expeditedFees) {
    t5 = !!pricing.expeditedFees && <OrderSummaryLine label="Rush Order" value={pricing.expeditedFees} />;
    $[12] = pricing.expeditedFees;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== pricing.retailDeliveryFees) {
    t6 = !!pricing.retailDeliveryFees && <OrderSummaryLine label="Estimated Retail Fees*" value={pricing.retailDeliveryFees} />;
    $[14] = pricing.retailDeliveryFees;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  let t8;
  if ($[16] !== cart) {
    t7 = <OrderSummarySitewidePromo cart={cart} />;
    t8 = <OrderSummaryCoupon cart={cart} />;
    $[16] = cart;
    $[17] = t7;
    $[18] = t8;
  } else {
    t7 = $[17];
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="pt-4 text-xs">* Prices are estimated based on your current location and without tax exemption. Final prices will be shown during checkout.</p>;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
    t10 = <CollapsibleContent className="motion-safe:data-[state=closed]:animate-collapsible-up motion-safe:data-[state=open]:animate-collapsible-down overflow-hidden border-t border-neutral-200 bg-neutral-100"><div className="space-y-2.5 p-4 text-sm">{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}</div></CollapsibleContent>;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== isOpen || $[29] !== t1 || $[30] !== t10) {
    t11 = <Collapsible open={isOpen} onOpenChange={setIsOpen} className="border-t border-neutral-200">{t1}{t10}</Collapsible>;
    $[28] = isOpen;
    $[29] = t1;
    $[30] = t10;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}